export const MARGIN_BOTTOM_SIZES = {
  s: "mb-s",
  m: "mb-m",
  l: "mb-l",
  xl: "mb-xl",
  xxl: "mb-xxl",
} as const

export const GAP_SIZES = {
  xs: "gap-xs",
  s: "gap-s",
  m: "gap-m",
  l: "gap-l",
  xl: "gap-xl",
  xxl: "gap-xxl",
} as const

export type MarginBottomSize = keyof typeof MARGIN_BOTTOM_SIZES
export type GapSize = keyof typeof GAP_SIZES
